import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, Zap, Lock } from 'lucide-react';
import { CountdownDark } from './Countdown';
import { getCheckoutUrl } from '../lib/utm';
const CHECKOUT_URL = 'https://axe-ia-tech.impultienda.ar/checkout';
export function Hero() {
  const checkoutUrl = getCheckoutUrl(CHECKOUT_URL);
  return <section className="pt-24 pb-16 px-4 relative overflow-hidden" data-id="element-105">
      <div className="absolute inset-0 bg-gradient-to-b from-orange-50 via-orange-50/50 to-slate-50 -z-10" data-id="element-106" />

      <div className="max-w-5xl mx-auto" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-108">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-blue-800 mb-6 leading-tight tracking-tight" data-id="element-109">
            Convertí tu publicidad en un <br className="hidden md:block" data-id="element-110" />
            sistema que genera clientes con IA
          </h1>
          <p className="text-lg md:text-xl text-slate-600 max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-111">
            Cargás tu marca una sola vez y en minutos generás tus creativos, tus
            copys, tus ángulos de venta y tu segmentación — listos para publicar
            en Meta y Google. Sin agencia, sin diseñador, sin saber de
            publicidad.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="rounded-[2rem] overflow-hidden shadow-2xl shadow-blue-900/20 mb-10 max-w-5xl mx-auto" data-id="element-112">
          <img src="https://cdn.magicpatterns.com/uploads/65ohzgxpJcJ5LwwN6NfQGQ/ChatGPT-Image-7-jul-2026_-11_42_05.webp" alt="Sistema Axe IA completo: panel en escritorio y móvil junto a los 5 bonos incluidos" className="w-full h-auto block" loading="eager" data-id="element-113" />
        </motion.div>

        <div className="max-w-md mx-auto" data-id="element-114">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="bg-white rounded-[2rem] p-6 md:p-8 shadow-xl border border-slate-100" data-id="element-115">
            <div className="flex items-center gap-2 mb-4 justify-center" data-id="element-116">
              <div className="flex text-yellow-400" data-id="element-117">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-118" />)}
              </div>
              <span className="text-sm font-bold text-slate-700" data-id="element-119">
                4.9 (500+ ventas)
              </span>
            </div>

            <div className="bg-red-50 text-red-600 text-xs font-bold px-3 py-1.5 rounded-full inline-block mb-6 uppercase tracking-wide text-center w-full" data-id="element-120">
              Acceso inmediato con descuento por tiempo limitado
            </div>

            <div className="flex items-baseline justify-center gap-3 mb-4" data-id="element-121">
              <span className="text-2xl text-slate-400 line-through font-medium" data-id="element-122">
                USD 242
              </span>
              <span className="text-5xl font-extrabold text-blue-800" data-id="element-123">
                USD 17
              </span>
            </div>

            <div className="text-green-600 font-bold text-center mb-2" data-id="element-124">
              ✅ Incluye 5 bonos GRATIS
            </div>
            <div className="text-green-600 font-bold text-center mb-6" data-id="element-125">
              Ahorrás USD 225 (93% OFF)
            </div>

            <div className="bg-red-50 text-red-700 text-center py-2 rounded-lg font-medium text-sm mb-3" data-id="element-126">
              🔥 Quedan <span className="font-bold" data-id="element-127">7 cupos</span> a este precio
            </div>

            <div className="bg-red-50 text-red-700 flex items-center justify-center gap-2 py-2 rounded-lg font-medium text-sm mb-6" data-id="element-128">
              <span data-id="element-129">⏳</span>
              <span data-id="element-130">La oferta termina en</span>
              <CountdownDark initialMinutes={5} initialSeconds={0} data-id="element-131" />
            </div>

            <motion.a href={checkoutUrl} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="block w-full bg-gradient-to-r from-blue-700 to-indigo-700 text-white text-center font-bold text-lg py-4 rounded-xl shadow-lg shadow-blue-500/30 mb-4 hover:from-blue-800 hover:to-indigo-800 transition-all uppercase" data-id="element-132">
              QUIERO EMPEZAR AHORA
            </motion.a>

            <div className="flex items-center justify-center gap-4 text-xs text-slate-500 font-medium" data-id="element-133">
              <div className="flex items-center gap-1" data-id="element-134">
                <Zap className="w-3 h-3" data-id="element-135" /> Entrega inmediata
              </div>
              <div className="flex items-center gap-1" data-id="element-136">
                <Lock className="w-3 h-3" data-id="element-137" /> Pago seguro
              </div>
              <div className="flex items-center gap-1" data-id="element-138">
                <ShieldCheck className="w-3 h-3" data-id="element-139" /> Garantía 7 días
              </div>
            </div>

            <div className="text-center text-xs text-slate-400 mt-4 flex items-center justify-center gap-1" data-id="element-140">
              <span className="relative flex h-2 w-2" data-id="element-141">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-142"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-143"></span>
              </span>
              16 personas viendo este producto ahora
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}